import { render, staticRenderFns } from "./InternalAmount.vue?vue&type=template&id=480e4f98&scoped=true&"
import script from "./InternalAmount.vue?vue&type=script&lang=js&"
export * from "./InternalAmount.vue?vue&type=script&lang=js&"
import style0 from "./InternalAmount.vue?vue&type=style&index=0&id=480e4f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e4f98",
  null
  
)

export default component.exports